// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"467d971c","488":"ddad1bde"}[chunkId] + ".chunk.js";
};